import React  from 'react';

const defaultValue = {
  impersonation: null
};

export default React.createContext(defaultValue);
